import type { JSX } from 'preact';

// Keyed by LABEL, not by a synthetic id. Login links moved off a hard-coded
// array (client/src/lib/managerLogins.ts) onto a real table (login_link,
// 077_login_link.sql, D-78) whose only durable id is a plain auto-increment
// bigint with no relationship to the old curated slugs this map used to key
// on ('qbt', 'universal-bg', 'mecentral', …) — several labels don't even
// slugify back to their old id (QuickBooks Time -> qbt, monday.com ->
// monday). Label is the one field that still identifies the same
// destination after that move. A row whose label no longer matches (edited,
// or a brand-new link) falls back to the existing wordmark rendering below
// — the same fallback path any never-mapped brand already used.
const FILES: Record<string, string> = {
  Edge: '/logos/edge.svg',
  'Massage Envy': '/logos/massage-envy.svg',
  Meevo: '/logos/meevo.svg',
  Rackspace: '/logos/rackspace.svg',
  SalonCloud: '/logos/saloncloud.svg',
  'ME Supplies': '/logos/me-supplies.svg',
  KDM: '/logos/kdm-mark.svg',
  'Virtual Terminal': '/logos/virtual-terminal.svg',
  'Florida Health': '/logos/florida-health-mark.svg',
  'QuickBooks Time': '/logos/quickbooks.svg',
  HelpDesk: '/logos/zoho.svg',
  AirTool: '/logos/d3.svg',
  Bindy: '/logos/bindy.svg',
  Tippy: '/logos/tippy.svg',
  'Universal Background': '/logos/universal-bg.svg',
  Sprockets: '/logos/sprockets.svg',
  'ME Central': '/logos/massage-envy.svg',
  'Franchise Portal': '/logos/massage-envy.svg',
  'monday.com': '/logos/monday.svg',
  Indeed: '/logos/indeed.svg',
  Staples: '/logos/staples.svg',
  Amazon: '/logos/amazon.svg',
  Verizon: '/logos/verizon.svg',
  ADP: '/logos/adp.svg',
  InMoment: '/logos/inmoment-mark.svg',
};

export function hasLoginMark(label: string): boolean {
  return Boolean(FILES[label]);
}

export function LoginMark({ label }: { label: string }): JSX.Element | null {
  const src = FILES[label];
  if (!src) return null;
  return <img src={src} alt="" />;
}
